/// <amd-module name="Feed/Legacy/Actions/FeedSettings/ValidationHandler" />
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";

export interface IValidationResult {
    /**
     * The name of the component associated with the error message
     */
    componentKey: string;

    /**
     * The error message. Null or empty for no error.
     */
    errorMessage: string;
}

/**
 * Keeps track of validation errors in components
 */
export class ValidationHandler {
    public static handle(state: IFeedSettingsState, emit: () => void, validation: IValidationResult[]): void {
        if (validation == null) {
            state.validationErrorBag = {};
            // components like button will get enabled or disabled based on validation result
            emit();
            return;
        } else if (validation.length == 1 && validation[0] == null) {
            state.validationErrorBag = {};
            // components like button will get enabled or disabled based on validation result
            emit();
            return;
        } else {
            let hasChange = false;
            validation.forEach(element => {
                if (element.errorMessage != null && element.errorMessage !== "") {
                    if (state.validationErrorBag[element.componentKey] == null) {
                        // there is an error now but there was previously no error
                        hasChange = true;
                        state.validationErrorBag[element.componentKey] = element.errorMessage;
                    } else if (state.validationErrorBag[element.componentKey] !== element.errorMessage) {
                        // there is an error now, there was previously an error, but it was different
                        hasChange = true;
                        state.validationErrorBag[element.componentKey] = element.errorMessage;
                    }
                } else if (state.validationErrorBag[element.componentKey] != null) {
                    // there isn't an error now, but previously there was one
                    hasChange = true;
                    state.validationErrorBag[element.componentKey] = null;
                }
            });

            if (hasChange) {
                emit();
            }
        }
    }
}
